module.exports = __webpack_public_path__ + "img/class-report-icon.97e25e57.png";